<template>
  <div id="app">

    <b-badge v-if="badgeEnv" class="badge-env" variant="danger"> {{ badgeEnv }}</b-badge>

    <!-- Pages without sidebar and navbar -->
    <div v-if="hideNavigation">
      <div>
        <router-view/>
      </div>
    </div>

    <!-- Pages with sidebar and navbar -->
    <div v-else>
      <div class="row no-gutters">
        <!-- sidebar -->
        <div v-if="!hideSideBar" class="parent-sidebar  col-md-3 col-lg-2 d-flex flex-column">
          <div id="sidebar">
            <div class="sidebar-content">
              <div
                v-if="this.$store.getters.isEstateAgent || this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus">
                <div v-if="this.pictureUrl" id="sidebar-header">
                  <img :src="this.pictureUrl" alt="Logo" class="sidebar-header-logo-user"
                       :class="{ 'reframe p-0':this.pictureReframe }">
                </div>
                <div v-else id="sidebar-header" style="position: relative;">
                  <img :src="require(`@/assets/images/APRILYOS/sidebar-logo-user.png`)" alt="Logo"
                       class="sidebar-header-logo-back">
                  <div class="header-text">
                    <b-link @click="editLogo">Ajouter votre logo<br/>depuis votre profil</b-link>
                  </div>
                </div>
              </div>
              <div v-else>
                <div id="sidebar-header">
                  <img :src="require(`@/assets/images/APRILYOS/sidebar-logo.png`)" alt="Logo" class="sidebar-header-logo">
                </div>
              </div>

              <b-nav class="sidebar-list" vertical>
                <SideMenu
                  :key="sideMenuKey"
                  :links="sidebarLinks"
                  :partners="partners"
                  :underlinks="sideBarUnderlinks">
                </SideMenu>
              </b-nav>
            </div>

            <div class="sidebar-footer mb-1">
              <div class="text-center">
                <img :src="brandLogoWhiteRed"
                     alt="LogoFooter"
                     class="sidebar-footer-logo"/>
                <br/>
                <br/>
                <b-link class="mt-0 text-center secondary-text-color" :href="`mailto:${brand.mailContact}`">
                  {{ brand.mailContact }}
                </b-link>
              </div>
            </div>

          </div>
        </div>

        <!-- navbar -->
        <div :class="hideSideBar ? 'ml-auto col-12 col-md-12 col-lg-12' : 'ml-auto col-12 col-md-9 col-lg-10'">
          <b-navbar toggleable="md">
            <div v-if="!isLoading&& (this.$store.getters.endFreeAccess != null)" class="d-flex">
              <div v-if="this.$store.getters.endFreeAccess" :class="this.$store.getters.endFreeAccess > 0 ? 'soon':'end'" class="nbDaysRemaining">
                {{ $t('freeAccess.remaining.days', {nbDays: this.$store.getters.endFreeAccess}) }}
              </div>
              <div class="d-flex flex-column  align-items-center justify-content-center custom-link ml-lg-4">
                <a v-html="$t('freeAccess.remaining.text')"></a>
              </div>
            </div>

            <div class="ml-auto row">
              <div v-if="(this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus) || (this.$store.getters.isEstateAgent && (this.$store.getters.currentUserSubscription === 'EXPERT' || this.$store.getters.currentUserSubscription === 'PRO'))" class="col">
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav>

                  <!-- Right aligned nav items -->
                  <b-navbar-nav class="d-none d-md-block">

                    <b-nav-item-dropdown right>
                      <!-- Using 'button-content' slot -->
                      <template #button-content>
                        {{ $store.getters.entreprise }}
                      </template>
                      <b-dropdown-item v-if="this.$store.getters.isEstateAgent" @click="showAddEntrepriseModal">
                        {{ $t('Add.entreprise') }}
                      </b-dropdown-item>
                      <b-dropdown-item :ref="refListEntreprise" v-for="entreprise in $store.getters.listEntreprises" @click="changeEntreprise(entreprise)" :key="entreprise.id">
                        {{ entreprise[1] }}
                      </b-dropdown-item>
                    </b-nav-item-dropdown>
                  </b-navbar-nav>

                </b-collapse>
              </div>
              <div class="col">
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav>

                  <!-- Right aligned nav items -->
                  <b-navbar-nav class="d-none d-md-block">

                    <b-nav-item-dropdown right>
                      <!-- Using 'button-content' slot -->
                      <template #button-content>
                        {{ $t('Settings') }}
                      </template>
                      <b-dropdown-item @click="goToProfile">
                        {{ $t('Profile') }}
                      </b-dropdown-item>
                      <b-dropdown-item v-if="$store.getters.masterUserId == null" @click="showMyAccountModal">
                        {{ $t('user.Password') }}
                      </b-dropdown-item>
                      <b-dropdown-item v-show="activeReportBug" @click="showReportBugModal">
                        {{ $t('Report.a.bug') }}
                      </b-dropdown-item>
                      <b-dropdown-item @click="logout">
                        {{ $t('Logout') }}
                      </b-dropdown-item>
                    </b-nav-item-dropdown>
                  </b-navbar-nav>

                </b-collapse>
              </div>
            </div>
          </b-navbar>

          <div class="page-container">
            <div v-if="$store.getters.impersonateUsername && TokenService().getImpersonateToken() && $store.getters.masterUserId == null" class="impersonate mt-4 ml-4 mr-4">
              <div class="impersonate-text ml-2"> Vous êtes connecté en tant que {{
                  $store.getters.impersonateUsername
                }}
              </div>
              <b-button class="mt-2 mb-2 mr-4" variant="secondary" @click="backToAdmin"> Retour à l'admin
              </b-button>
            </div>
            <router-view/>
          </div>

          <div class="main-footer">
            <p>Copyright &#169; 2024 {{ $t('TitleProjectUC') }}.
              <span style="white-space: nowrap;">All rights reserved.</span>
            </p>
            <p style="white-space: nowrap;">Made with
              <heart-icon class="text-danger"/>
              by <a href="https://www.bleu122.com/">Bleu122</a></p>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal My Account -->
    <change-password-modal v-if="$store.getters.masterUserId == null"></change-password-modal>
    <first-connexion-modal></first-connexion-modal>
    <show-bug-report-modal></show-bug-report-modal>
    <add-entreprise-modal></add-entreprise-modal>
  </div>

</template>

<script>

import ChangePasswordModal from './views/user/ChangePasswordModal'
import FirstConnexionModal from './views/user/FirstConnexionModal'
import ShowBugReportModal from "./components/b122/ShowBugReportModal";
import SideMenu from './views/menus/SideMenu'
import api from "./services/api";
import {bus} from "./main";
import TokenService from "./services/tokenService";
import {mapActions, mapGetters} from "vuex";
import * as Sentry from "@sentry/vue";
import AddEntrepriseModal from "./views/user/AddEntrepriseModal.vue";

export default {

  name: 'App',

  components: {
    ChangePasswordModal,
    FirstConnexionModal,
    ShowBugReportModal,
    AddEntrepriseModal,
    SideMenu
  },

  data() {
    return {
      sideMenuKey: 0,
      refLogo: 0,
      refListEntreprise: 0,
      isLoading: true,
      badgeEnv: null
    }
  },
  computed: {
    ...mapGetters('brand', ['brand']),

    brandLogoWhiteRed() {
      return require(`@/assets/images/${this.brand.key}/logo_white_red.png`)
    },

    pictureUrl() {
      return this.$store.getters.pictureUrl
    },
    pictureReframe() {
      return this.$store.getters.pictureReframe
    },
    hideNavigation() {
      return (!this.$store.getters.isAuthenticated || this.$store.getters.isAgentImmo)
    },
    hideSideBar() {
      return (this.$route.name === 'CommercialisationLotsShow' || this.$store.getters.isAgentImmo)
    },
    activeReportBug() {
      return ['preproduction', 'production'].includes(process.env.NODE_ENV)
    },

    partners() {
      if(this.$store.getters['brand/brandFeatures'].partenaires){
        return [
          {
            'name': 'PriceHubble',
            'link': 'https://dash.pricehubble.com/login',
            'logo': require(`@/assets/images/APRILYOS/pricehubble2.png`),
            'hidden': !this.$store.getters.isAdmin
          }
        ]
      }
      return []
    },
    sidebarLinks() {
      return [
        {
          'icon': 'home-icon',
          'title': this.$i18n.t('Dashboard'),
          'route': '/',
          'routesActiveItem': ['/','/clients','/clients/index','/dashboard/task/createEdit/', '/dashboard/task/show/'],
          'isExpendable': false,
        },
        {
          "icon": 'users-icon',
          "title": this.$i18n.t('dashboard.users.title.admin'),
          "route": '/dashboardAdmin/index',
          "routesActiveItem": ['/dashboardAdmin/index'],
          "isExpendable": false,
          "hidden": !this.$store.getters.isAdmin
        },
        {
          'icon': 'heart-handshake-icon',
          'title': this.$i18n.t('partenaires'),
          'route': '/partenaire/index',
          'routesActiveItem': ['/partenaire', '/partenaire/index'],
          'isExpendable': false,
          'hidden': !this.$store.getters.isAdmin
        },
        {
          'icon': 'users-icon',
          'title': this.$i18n.t('Collaborators'),
          'route': '/user/index',
          'routesActiveItem': ['/user/show', '/user/create', '/user/edit'],
          'isExpendable': false,
          'hidden': this.$store.getters.isAdmin || this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus
        },
        {
          'icon': 'map-search-icon',
          'title': this.$i18n.t('UrbanStudy'),
          'route': '/urbanStudy/index',
          'routesActiveItem': ['/urbanStudy/show', '/urbanStudy/create', '/urbanStudy/edit'],
          'isExpendable': false,
          'hidden': this.$store.getters.isAdmin
        },
        {
          'icon': 'help-icon',
          'title': this.$i18n.t('Simulations'),
          'route': '/simulation/index',
          'routesActiveItem': ['/simulation/show', '/simulation/createEdit'],
          'isExpendable': false,
          'hidden': this.$store.getters.isAdmin
        },
        {
          'icon': 'building-community-icon',
          'title': this.$i18n.t('Operations'),
          'route': '/operation/index',
          'routesActiveItem': ['/operation/show', '/operation/create', '/operation/edit'],
          'isExpendable': false,
          'hidden': this.$store.getters.isAdmin
        },
        {
          'icon': 'home-dollar-icon',
          'title': this.$i18n.t('Commercialisation'),
          'route': '/commercialisationlots/index',
          'routesActiveItem': ['/commercialisationlots/show'],
          'isExpendable': false,
          'hidden': (!this.$store.getters.isEstateAgent && !this.$store.getters.isCollaboratorPlus)
        },
        {
          'icon': 'briefcase-icon',
          'title': this.$i18n.t('VenteLot'),
          'route': '/venteLot/index',
          'routesActiveItem': ['/venteLot/show'],
          'isExpendable': false,
          'hidden': (!this.$store.getters.isEstateAgent && !this.$store.getters.isCollaboratorPlus)
        },
        // {
        //   'icon': 'calendar-icon',
        //   'title': this.$i18n.t('Planning'),
        //   'route': '/planning/index',
        //   'routesActiveItem': ['/planning/show', '/planning/create', '/planning/edit'],
        //   'isExpendable': false,
        //   'hidden': this.$store.getters.isAdmin
        // },
        {
          'icon': 'currency-euro-icon',
          'title': this.$i18n.t('Treasury.global'),
          'route': '/treasury/index',
          'routesActiveItem': ['/treasury/show', '/treasury/create', '/treasury/edit'],
          'isExpendable': false,
          'hidden': (!this.$store.getters.isEstateAgent && !this.$store.getters.isCollaboratorPlus)
        },
        {
          'icon': 'building-bank-icon',
          'title': this.$i18n.t('Investors'),
          'route': '',
          'isExpendable': true,
          'expendableId': "navbar-toggle-investors",
          'underlinksIndex': 0,
          'hidden': (!this.$store.getters.isEstateAgent && !this.$store.getters.isCollaboratorPlus)
        },
        {
          'icon': 'calculator-icon',
          'title': this.$i18n.t('SocietyBalanceSheet'),
          'route': '/societyBalanceSheet/index',
          'routesActiveItem': ['/societyBalanceSheet/show', '/societyBalanceSheet/create', '/societyBalanceSheet/edit'],
          'isExpendable': false,
          'hidden': (!this.$store.getters.isEstateAgent && !this.$store.getters.isCollaboratorPlus)
        },
        {
          'icon': 'wallet-icon',
          'title': this.$i18n.t('ProfessionalCharges'),
          'route': '/professionalCharges/index',
          'routesActiveItem': ['/professionalCharges/createEdit'],
          'isExpendable': false,
          'hidden': (!this.$store.getters.isEstateAgent && !this.$store.getters.isCollaboratorPlus)
        },
        {
          'icon': 'users-icon',
          'title': this.$i18n.t('Directory'),
          'route': '/contact/index',
          'routesActiveItem': ['/contact/show', '/contact/create', '/contact/edit'],
          'isExpendable': false,
          'hidden': this.$store.getters.isAdmin
        },
        {
          'icon': 'heart-handshake-icon',
          'title': this.$i18n.t('partenaires.find'),
          'route': '/partenaire/index',
          'routesActiveItem': ['/partenaire', '/partenaire/index'],
          'isExpendable': false,
          'hidden': this.$store.getters.isAdmin || (!this.$store.getters.isAdmin && !this.$store.getters['brand/brandFeatures'].tutorials)
        },
        {
          'icon': 'brand-youtube-icon',
          'title': this.$i18n.t('Tutorials'),
          'route': '/tutorial/index',
          'routesActiveItem': ['/tutorial/create', '/tutorial/edit'],
          'isExpendable': false,
          'hidden': !this.$store.getters['brand/brandFeatures'].tutorials
        },
      ]
    },

    sideBarUnderlinks() {
      return [
        [
          {
            'title': this.$i18n.t('Contrat.s'),
            'route': '/investor/contrat/index',
            'routesActiveItem': ['/investor/contrat/index', '/investor/contrat/createEdit', '/investor/show/']
          },
          {
            'title': this.$i18n.t('Interest.s'),
            'route': '/investor/interest/index',
            'routesActiveItem': ['/investor/interest/index', '/investor/interest/createEdit']
          }
        ]
      ]
    }

  },

  created() {
    bus.$on("updateListEntreprises", () => {
      this.getListEntreprises()
    })

    bus.$on("editProfile", () => {
      this.fetchUserInfos()
    })

    bus.$on("changingImpersonate", () => {
      this.forceSideMenuRerender()
    })

    bus.$on('showBugReportModal', () => {
      this.showReportBugModal()
    });
    const userProperties = [
      'username',
      'roles',
      'isAdmin',
      'isEstateAgent',
      'isCollaborator',
    ]
    const userForSentry = {};
    userProperties.forEach(key => {
      userForSentry[key] = this.$store.getters[key];
    });
    Sentry.setUser(userForSentry)
    Sentry.setTag('userId', this.$store.getters.userId)
  },

  mounted() {
    if (localStorage.locale != null) {
      this.$i18n.locale = localStorage.locale
    }
    this.fetchEnvironment()
  },

  methods: {
    TokenService() {
      return TokenService
    },

    ...mapActions(["updateListEntreprises", "leaveMultiEntreprise", "setImpersonateMode", "leaveImpersonateMode", "fetchPendingAnnouncementsCount", "changeUserEstateAgent"]),

    async getListEntreprises() {
      if (this.$store.getters.isEstateAgent && this.$store.getters.masterUserId == null) {
        await api
          .get(`/user/getListEntreprises/${this.$store.getters.userId}`)
          .then(async response => {
            await this.updateListEntreprises(response.data)
            this.refListEntreprise++
          })
      }
    },

    async fetchEnvironment() {
      const response = await api.get('/home/getEnvironmentName');
      let badgeStr = null
      if (response.data.toString() !== 'production') {
        badgeStr = response.data.toString().length > 7 ? response.data.toString().substring(0, 3).toUpperCase() : response.data.toString().toUpperCase()
      }
      this.badgeEnv = badgeStr
      await api
        .get(`/user/getListEntreprises/${this.$store.getters.userId}`)
        .then(async response => {
          await this.updateListEntreprises(response.data)
          this.refListEntreprise++
        })
    },

    async logout() {
      this.$store.commit('setUnsavedChanges', false);
      await this.$store.dispatch('LogOut')
      await this.$router.push('/login')
    },

    forceSideMenuRerender() {
      this.sideMenuKey++;
    },
    showMyAccountModal() {
      this.$bvModal.show('change-password-modal')
    },

    goToProfile() {
      this.$router.push({
        name: 'ProfileShow'
      })
    },

    backToAdmin() {
      TokenService.removeImpersonate()
      this.leaveImpersonateMode()
      this.forceSideMenuRerender()
      this.$router.push({
        name: 'Dashboard'
      })
    },

    editLogo() {
      this.$router.push({
        name: "ProfileEdit"
      })
    },

    async fetchUserInfos() {
      console.log("fetchUserInfos")
      if (this.$store.getters.isAuthenticated) {
        await api
          .get(`/user/getUserInfos`)
          .then(async response => {
            this.$store.state.endFreeAccess = response.data.endFreeAccess
            this.$store.state.subscriptionType = response.data.subscriptionType
            this.$store.state.listEntreprises = response.data.listEntreprises
            this.refLogo++
          })
        this.fetchPendingAnnouncementsCount()
      }
      this.isLoading = false
    },

    showReportBugModal() {
      this.$bvModal.show('show-bug-report-modal');
    },

    showAddEntrepriseModal() {
      this.$bvModal.show('add-entreprise-modal');
    },

    changeEntreprise(entreprise) {
      bus.$emit("changingImpersonate");

      if (this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus) {

        let data = new FormData();
        data.append('id', entreprise[2]);
        api({
          method: 'POST',
          url: `user/changeUserEstateAgent`,
          data: data
        })
          .then(async (response) => {
            await this.changeUserEstateAgent(response.data)
            if (this.$route.name === 'Dashboard') {
              window.location.reload()
            } else {
              this.$router.replace({
                name: 'Dashboard',
              })
            }

          });

      } else {
        if (TokenService.getUser().username === entreprise[0]) {
          let data = new FormData();
          data.append('username', entreprise[0]);
          api({
            method: 'POST',
            url: `user/leaveImpersonate`,
            data: data
          })
            .then((response) => {
              TokenService.removeImpersonate()
              this.leaveMultiEntreprise(response.data);
              window.location.reload()
            });
        } else {
          let data = new FormData();
          data.append('username', entreprise[0]);
          api({
            method: 'POST',
            url: `user/impersonate`,
            data: data
          })
            .then((response) => {
              TokenService.addImpersonate(response.data.impersonateToken);
              this.setImpersonateMode(response.data);
              window.location.reload()
            });
        }
      }
    }
  }

}
</script>

<style scoped>

#sidebar {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  min-height: 100vh;
  top: 0;
  z-index: 2;
  box-shadow: 3px 0 5px rgba(0, 0, 0, 0.15);
  background-color: var(--main-color);
}

#sidebar-header {
  display: flex;
  justify-content: center;
  background: #FFFFFF;
}

.sidebar-header-logo {
  width: 100%;
}

.sidebar-header-logo-back {
  width: auto;
  height: 150px;
  margin-left: auto;
}

.sidebar-footer-logo {
  width: 80%;
}

.main-footer {
  position: absolute;
  width: 96%;
  height: 3rem;
  display: flex;
  justify-content: space-between;
  margin: 0 2%;
  padding-top: 10px;
  border-top: 1px solid #D0CFCF;
}

.page-container {
  position: relative;
  min-height: 87vh;
  padding-bottom: 3rem;
}

.content-wrap {
  padding-bottom: 3rem; /* Footer height */
}

@media only screen and (max-width: 991px) and (min-width: 768px) {
  .main-footer {
    width: 96%;
    height: 3.5rem;
  }

  .content-wrap {
    padding-bottom: 3.5rem; /* Footer height */
  }
}

@media only screen and (max-width: 767px) {
  .sidebar-header-logo {
    width: 100px;
  }

  .sidebar-footer-logo {
    width: 80px;
  }

  .main-footer {
    width: 96%;
    font-size: 12px;
    height: 3.5rem;
  }

  .content-wrap {
    padding-bottom: 3.5rem; /* Footer height */
  }

  .page-container {
    min-height: 82vh;
  }
}


.impersonate {
  background-color: var(--main-color);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: var(--main-border-radius);
}

.impersonate-text {
  align-self: center;
  color: var(--main-white);
}

.nbDaysRemaining {
  position: relative;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  border-radius: var(--main-border-radius);
  padding: 8px;
  color: var(--main-color-text);
  font-family: "Montserrat-Bold", "Arial", sans-serif;
}

.custom-link {
  color: var(--main-white);
}

.soon {
  background-color: var(--main-white);
  color: var(--main-color-text);
}

.end {
  background-color: var(--main-red);
  color: var(--main-white);
}

.sidebar-footer {
  margin-top: auto;
  width: 96%;
  display: flex;
  justify-content: space-between;
}

.header-text {
  color: var(--main-color-text);
  position: absolute;
  left: 50%; /* horizontal alignment */
  top: 50%; /* vertical alignment */
  transform: translate(-50%, -50%); /* precise centering; see link below */
  text-align: center;
  width: 100%;
  font-size: 16px;
}

.badge-env {
  padding: 8px;
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 20;
  font-size: 14px;
  background-color: var(--main-red);
}

.parent-sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
}

.sidebar-content {
  flex: 1;
  overflow-y: auto;
}

</style>



// WEBPACK FOOTER //
// src/App.vue